export const FETCH_CREDIT_REQUEST = 'FETCH_CREDIT_REQUEST'
export const FETCH_CREDIT_SUCCESS = 'FETCH_CREDIT_SUCCESS'
export const FETCH_CREDIT_ERROR = 'FETCH_CREDIT_ERROR'
export const FETCH_CREDIT_RESULT_SUCCESS = 'FETCH_CREDIT_RESULT_SUCCESS'
export const FETCH_CREDIT_RESULT_ERROR = 'FETCH_CREDIT_RESULT_ERROR'
export const LOADING_SIMULATION_RESULT = 'LOADING_SIMULATION_RESULT'
export const SEND_SOLICITUD_CREDITO = 'SEND_SOLICITUD_CREDITO'
export const GET_SIMULATION_CREDIT = 'GET_SIMULATION_CREDIT'
export const NEXT_STEP_SIMULATION = 'NEXT_STEP_SIMULATION'
export const PREV_STEP_SIMULATION = 'PREV_STEP_SIMULATION'
export const PUT_DECLARACION_JURADA = 'PUT_DECLARACION_JURADA'
export const USER_PENDIENTE_PC = 'USER_PENDIENTE_PC'